module.exports = __webpack_public_path__ + "img/4m.b14e1174.jpg";